import React from "react";
import { StatusBarTargetContext } from "./StatusBarTargetContext";
import { StatusBarZoomContextProvider } from "./StatusBarZoomContext";

type StatusBarContextProviderProps = React.PropsWithChildren<{
    // The DOM element where status-bar items are rendered through portals.
    target: HTMLDivElement | null;
}>;

// Groups the independent status-bar target and zoom contexts under one application provider.
export const StatusBarContextProvider: React.FunctionComponent<StatusBarContextProviderProps> = ({ children, target, }) => (<StatusBarTargetContext.Provider value={target}>
        <StatusBarZoomContextProvider>{children}</StatusBarZoomContextProvider>
    </StatusBarTargetContext.Provider>);
